module.exports = __webpack_public_path__ + "img/faixa0.24fae1d2.png";